import styled from 'styled-components';

export const ErrorContainer = styled.div`
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: ${(props) =>
        props.theme.theme === 'light' ? '#fff' : '#141414'};
    padding: 20px;
`;

export const ErrorDescription = styled.p`
    color: ${(props) => (props.theme.theme === 'light' ? '#666' : '#ccc')};
    max-width: 300px;
    text-align: center;
    font-size: 12px;
`;

export const ErrorMessage = styled.h1`
    font-size: 24px;
    color: ${(props) => (props.theme.theme === 'light' ? '#333' : '#fff')};
`;
